<input #deckCardSearch (focus)="onInputFocus()" class="p-1 min-h-8 rounded-sm shadow-sm text-xs sm:text-sm" type="text" placeholder="Add a card" [ngClass]="{ 'bg-ponder-xlight text-slate-50' : isMobileScreen(), 'bg-slate-50' : !isMobileScreen() }">
@if (shouldShow) {
    <div class="absolute max-w-36 sm:max-w-72 max-h-[300px] z-30 overflow-y-auto bg-slate-100 shadow text-xs sm:text-sm">
            <div class="flex flex-col overflow-x-clip">
                @for (searchResult of searchResults; track searchResult.item.name) {
                    <div 
                        (click)="onResultClicked(searchResult)"
                        class="p-1 hover:cursor-pointer hover:bg-ponder-linkhover hover:bg-opacity-15 border-t sm:truncate"
                        [ngClass]="{'font-bold' : ($index == 0 && hasExactMatch)}">
                        {{ searchResult.item.name }}
                    </div>
                }
            </div>
    </div>
}